(function () {
  function refresh(clamp) {
    var btn = clamp.parentElement.querySelector('[data-read-more]');
    if (!btn) return;
    if (clamp.classList.contains('is-expanded')) return;
    var overflow = clamp.scrollHeight > clamp.clientHeight + 2;
    btn.hidden = !overflow;
  }

  function toggle(btn) {
    var clamp = btn.parentElement.querySelector('[data-clamp]');
    if (!clamp) return;

    var content = btn.closest('.text__content');
    var isCurrentlyExpanded = btn.getAttribute('aria-expanded') === 'true';
    var willExpand = !isCurrentlyExpanded;

    btn.setAttribute('aria-expanded', String(willExpand));

    // Toggle classes on clamp and container
    clamp.classList.toggle('is-expanded', willExpand);
    if (content) {
      content.classList.toggle('expanded', willExpand);
    }

    // Force style update directly via JS variable override
    if (willExpand) {
      clamp.style.setProperty('--clamp-lines', '999999');
    } else {
      clamp.style.removeProperty('--clamp-lines');
    }

    if (willExpand && btn.hasAttribute('data-hide-on-expand')) {
      btn.hidden = true;
      return;
    }

    var label = btn.querySelector('[data-read-more-label]') || btn;
    label.textContent = willExpand ? btn.getAttribute('data-less-text') : btn.getAttribute('data-more-text');
  }

  function bindButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-read-more]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle(btn);
      });
    });
  }

  function setup(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-clamp]').forEach(refresh);
    bindButtons(scope);
  }

  if (document.readyState !== 'loading') {
    setup();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      setup();
    });
  }

  window.addEventListener('resize', function () {
    setup();
  });

  document.addEventListener('shopify:section:load', function (e) {
    setup(e.target);
  });
})();